/** ESCHER FALLS — Türkçe。 */

import type { Strings } from './ja';

export const TR: Strings = {
  pour: 'Suyu bırak',
  lever: 'Kol',
  leverAria: 'Kolu çek',
  retry: 'Baştan başla',
  again: 'Tekrar',
  next: 'Sonraki',
  share: 'Bu kareyi paylaş',
  shareFailed: 'Paylaşılamadı',
  rotateLeft: 'Görüşü sola çevir',
  rotateRight: 'Görüşü sağa çevir',
  tiltUp: 'Görüşü yükselt',
  tiltDown: 'Görüşü indir',
  topDown: 'Yukarıdan',
  water: (left, total) => `Su ${left} / ${total}`,
  moves: (left, total) => `Hamle ${left} / ${total}`,
  timeLeft: (time) => `Kalan ${time}`,
  drops: (n) => `${n} damla`,

  resultClear: 'Geçti',
  resultFail: 'Geçmedi',
  clearTitle: 'Su geçti',
  fail: {
    time: 'Süre doldu',
    moves: 'Hamle kalmadı',
    drywell: 'Su kuru kuyuya aktı',
    water: 'Su tükendi',
    deadend: 'Su çıkmaz bir yere düştü',
  },
  extendByAd: 'Reklam izleyip 30 saniye kazan',
  extendByDrops: (cost) => `30 saniye için ${cost} damla`,
  multiplyByAd: (mult) => `Reklam izleyip ×${mult} damla`,

  stages: 'Bölümler',
  settingsAria: 'Ayarlar',
  menuAria: 'Menü',
  back: 'Geri',
  loop1: 'Birinci tur',
  loop2: 'İkinci tur',
  loopNote: 'İkinci turda hamle ve süre daha sıkı. Kayıtlar ayrı tutulur.',
  shop: 'Mağaza',
  groupMain: 'Ana bölüm',
  groupExtra1: 'Ekstralar',
  groupExtra2: 'Ekstralar II',
  freeTrial: 'Ücretsiz',
  notPurchased: (n, name) => `${n} ${name} (kilitli)`,
  lockedStage: 'Kilitli bölüm',
  extraLockedFree: '1. bölüm, “Tersine Şelale”, ücretsiz. Diğerleri Ayarlar (≡) üzerinden satın alınca açılır.',
  extraLocked: 'Ayarlar (≡) üzerinden satın alınca açılır.',
  extra2Locked: '11. bölümden itibaren, 1–10. bölümlerin tümünden su geçince açılır.',
  extra2LockedUnowned: 'Ayarlar (≡) üzerinden satın alın ve 11. bölümden itibarenkileri açmak için 1–10. bölümleri bitirin.',
  extra2Note: 'Tüm ekstra bölümlerden su geçince açılır.',
  progress: (cleared, total) => `Ana bölüm ${cleared} / ${total} tamam`,
  totalTime: (time) => `Toplam ${time}`,
  totalNone: 'Toplam —',

  settings: 'Ayarlar',
  bgm: 'Ortam sesi',
  se: 'Efektler',
  testSound: 'Sesi dene',
  audioStatus: (state) => `Ses: ${state}`,
  audioState: {
    locked: 'Kapalı (ekrana bir kez dokunun)',
    running: 'Çalışıyor',
    suspended: 'Duraklatıldı',
  },
  demoNote: (n) => `Bu ${n} bölüm web demosu. 42 bölümün tamamı uygulamada.`,
  demoGet: 'App Store’dan indir',
  // — 今日の一面（日替わり）
  dailyTitle: 'Günün bölümü',
  dailyLoading: 'Yükleniyor…',
  dailyOffline: 'Bağlantı yok, günün bölümü açılamıyor',
  dailyPlay: 'Oyna',
  dailyCleared: (time: string) => `${time} sürede geçildi`,
  archiveTitle: 'Geçmiş bölümler',
  upcomingTitle: 'Gelecek bölümler',
  archiveLocked: 'Son 3 gün ücretsiz. Daha eskileri açmak için Ekstraları satın alın',
  language: 'Dil',
  languageAuto: 'Cihazı izle',
  palette: 'Renk düzeni',
  worn: 'Kullanımda',
  owned: 'Sahip',
  buyDrops: 'Damla satın al',
  restore: 'Satın alımları geri yükle',
  writeReview: 'Bu uygulamayı değerlendir',
  moreApps: 'Yapımcının diğer işleri',
  restoreChecking: 'Kontrol ediliyor…',
  restoreDone: (n) => `${n} tanesi geri yüklendi`,
  restoreNone: 'Geri yüklenecek bir şey yok',
  restoreFailed: 'Geri yüklenemedi',
  chooseStage: 'Bölüm seç',
  resume: 'Devam et',

  prizeLabel: 'Ödül',
  awardLabel: 'Unvan',
  toExtra: 'Ekstralara',
  toLoop2: 'İkinci tura',
  toStart: 'Başa',
  allClearTitle: 'Hepsi geçildi',
  allClearBody: (n) => `${n} su yolunun tamamından su geçti`,
  multiplyTimes: (mult) => `Reklam izleyip ×${mult}`,
  noteRank: 'Unvan kayıtlarda kalır ve bölüm listesinin üstünde görünür.',
  noteLoop2: 'İkinci tur açıldı. Hamle ve süre daha sıkı.',
  notePartOne: 'Birinci bölüm burada bitiyor. Su henüz yükselmedi.',
  inviteTry: 'Ekstra 1’i dene',
  inviteOpen: 'Ekstralar I’i aç — 20 bölüm',
  dateLine: (d) =>
    `${d.getDate()} ${['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'][d.getMonth()]} ${d.getFullYear()}`,

  completionTitle: 'Sonsuzu Geçen',
  rank: {
    none: '—',
    sovereign: 'Suyun hükümdarı',
    architect: 'Şelale mimarı',
    mason: 'Taş ustası',
    apprentice: 'Çırak',
    wayfarer: 'Yolcu',
  },

  skin: {
    hakushi: 'Boş kâğıt',
    ai: 'Çivit',
    koke: 'Yosun',
    shu: 'Zincifre',
    sumi: 'Sumi mürekkebi',
  },

  product: {
    drops600: '600 damla',
    drops1600: '1.600 damla',
    drops5000: '5.000 damla',
    noads: 'Reklamları kaldır',
    extras: 'Ekstralar I — 21 bölüm (reklamsız)',
  },
};
